import { Skeleton, Flex } from '@eqi-investimentos/react';

export const SelectAssetSectionSkeleton = () => (
  <Flex flexDir="column" gap="2xl" py="xl">
    {Array.from({ length: 21 }).map((_, index) => (
      <Flex
        flexDir="row"
        w="full"
        key={index}
        justify="space-between"
        alignItems="center"
      >
        <Flex gap="xs" flexDirection="row" w="full">
          <Skeleton w="35px" h="30px" />
          <Skeleton w="200px" h="30px" />
        </Flex>
        <Skeleton w="24px" h="24px" />
      </Flex>
    ))}
  </Flex>
);
